module.exports = __webpack_public_path__ + "static/media/inspiron_presentation.66351b9b.jpg";